<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div
            class="header d-flex justify-content-between align-items-center gap-2 flex-wrap"
          >
            <div>
              <h2>Manage Category</h2>
            </div>
            <div class="d-flex align-items-center mr-3" style="gap: 10px">
              <form
                [formGroup]="filterForm"
                (ngSubmit)="onFilterBy()"
                class="d-flex gap-3 items-center"
                style="gap: 10px"
              >
                <div class="d-flex flex-column">
                  <label for="status">Filter by</label>
                  <select
                    name="status"
                    id="status"
                    formControlName="status"
                    class="form-control"
                  >
                    <option *ngFor="let f of filters" [value]="f.value">
                      {{ f.name }}
                    </option>
                  </select>
                </div>
                <div class="align-self-end">
                  <button
                    class="btn btn-primary"
                    [disabled]="filterForm.invalid"
                    type="submit"
                  >
                    Filter
                  </button>
                </div>
              </form>
            </div>
            <div class="align-self-end">
              <button
                class="cursor-pointer btn btn-primary text-white"
                (click)="addCategory()"
              >
                Add category
              </button>
            </div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData">
              <span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading,
              Please wait...
            </div>

            <div class="table-responsive" *ngIf="changeOccured">
              <table
                id="categories"
                class="table table-bordered table-hover table-striped dataTable"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <!-- <th class="no-sort" width="5%"></th> -->
                    <th>#</th>
                    <th>Name</th>
                    <th>Slug</th>
                    <th>Daily Fee</th>
                    <th>Enrollment Fee</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <!-- <th class="no-sort"></th> -->
                    <th>#</th>
                    <th>Name</th>
                    <th>Slug</th>
                    <th>Daily Fee</th>
                    <th>Enrollment Fee</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </tfoot>
                <tbody>
                  <tr *ngFor="let c of categories; let i = index">
                    <!-- <td class="details-control" [id]="'td-' + i" ></td> -->
                    <td>{{ i + 1 }}</td>
                    <td>{{ c?.name }}</td>
                    <td>{{ c?.slug }}</td>
                    <td>&#8358;{{ c?.daily_fee }}</td>
                    <td>&#8358;{{ c?.enrollment_fee }}</td>
                    <td>{{ c?.status }}</td>
                    <td>
                      <div class="d-flex align-items-center" style="gap: 10px">
                        <button
                          [disabled]="toggled && categoryId === c.id"
                          class="btn btn-sm btn-success"
                          *ngIf="c?.status.toLowerCase() === 'inactive'"
                          (click)="toggleAgentStatus(c.id, 'enable')"
                        >
                          {{
                            toggled && categoryId === c.id
                              ? "Enabling"
                              : "Enable Category"
                          }}
                        </button>
                        <button
                          [disabled]="toggled && categoryId === c.id"
                          class="btn btn-sm btn-danger"
                          *ngIf="c?.status.toLowerCase() === 'active'"
                          (click)="toggleAgentStatus(c.id, 'disable')"
                        >
                          {{
                            toggled && categoryId === c.id
                              ? "Disabling"
                              : "Disable Category"
                          }}
                        </button>
                        <!-- <button [disabled]="deleting && categoryId === c.id" class="btn btn-sm btn-danger" (click)="deleteCategory(c.id)">{{ deleting && categoryId === c.id  ? 'Deleting' : 'Delete Category'}}</button> -->

                        <span
                          class="badge badge-info"
                          *ngIf="c?.status.toLowerCase() === 'inactive'"
                          >Awaiting Approval</span
                        >
                        <span
                          class="badge badge-success"
                          *ngIf="c?.status.toLowerCase() === 'active'"
                          >Approved</span
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Category modal -->

<app-modal [modalId]="'categoryModal'" [modalTitle]="'Add Category'">
  <form [formGroup]="categoryForm" (ngSubmit)="addCategoryForm()" class="p-3">
    <div class="col-12">
      <label for="name" class="mb-2 fw-bold">Name</label>
      <input
        class="form-control"
        type="text"
        id="name"
        formControlName="name"
        placeholder="Enter category Name"
      />
    </div>
    <div class="row mt-2 pl-3 pr-3">
      <!-- Daily Fee -->
      <div class="col-12 col-md-6 mb-3">
        <label for="dailyFee" class="form-label fw-bold"> Daily Fee </label>
        <div class="input-group">
          <span class="input-group-text">₦</span>
          <input
            type="text"
            id="dailyFee"
            class="form-control"
            formControlName="daily_fee"
            placeholder="Enter Daily Fee"
          />
        </div>
        <small
          *ngIf="categoryForm.get('daily_fee')?.hasError('pattern')"
          class="text-danger"
        >
          Must be a number
        </small>
      </div>

      <!-- Enrollment Fee -->
      <div class="col-12 col-md-6 mb-3">
        <label for="enrollmentFee" class="form-label fw-bold">
          Enrollment Fee
        </label>
        <div class="input-group">
          <span class="input-group-text">₦</span>

          <input
            type="text"
            id="enrollmentFee"
            class="form-control"
            formControlName="enrollment_fee"
            placeholder="Enter Enrollment Fee"
          />
        </div>
        <small
          *ngIf="categoryForm.get('enrollment_fee')?.hasError('pattern')"
          class="text-danger"
        >
          Must be a number
        </small>
      </div>
    </div>
    <div class="modal-footer mt-4 d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-outline-danger" data-dismiss="modal">
        Cancel
      </button>

      <button
        type="submit"
        *ngIf="!submitting"
        [disabled]="categoryForm.invalid"
        class="btn btn-primary px-4"
      >
        <i class="fa fa-user-plus me-2"></i>
        Add Category
      </button>

      <span *ngIf="submitting" class="btn btn-primary px-4">
        Loading&nbsp;
        <i class="fa fa-spin fa-spinner"></i>
      </span>
    </div>
  </form>
</app-modal>